const FILES_KEY = {
  DATA: 'data'
}

export default FILES_KEY
